import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-5', 'Number5', [["path",{"d":"M8 20h4a4 4 0 1 0 0 -8h-4v-8h8"}]]);